export default __webpack_public_path__ + "static/media/VFW_NCO.3e5f29a0.jpg";